import { render, staticRenderFns } from "./WorthChooseUsBlock.vue?vue&type=template&id=683958aa&scoped=true&"
import script from "./WorthChooseUsBlock.vue?vue&type=script&lang=js&"
export * from "./WorthChooseUsBlock.vue?vue&type=script&lang=js&"
import style0 from "./WorthChooseUsBlock.vue?vue&type=style&index=0&id=683958aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683958aa",
  null
  
)

export default component.exports